module.exports = __webpack_public_path__ + "img/about-10.0cb03713.png";